webpackJsonp([9],{

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35e92c56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addNewNotice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function addNewNotice(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/addNewNotice',
    data: data,
    method: 'post'
  });
}

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_notice_js__ = __webpack_require__(523);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      startMain: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['welcome'])),
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '出题',
        message: msg,
        type: type
      });
    },
    commit: function commit() {},
    add_new_notice: function add_new_notice() {
      var _this = this;

      var sm = {};
      sm.notice = this.noticeText;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_notice_js__["a" /* addNewNotice */])(sm).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this.showMsg('公告已发布。', 'info');
          } else {
            _this.showMsg('公告发布失败。', 'info');
          }
        } else {
          _this.showMsg('公告发布不成功。', 'info');
        }
      }).catch(function (err) {
        _this.showMsg('\u516C\u544A\u53D1\u5E03\u5931\u8D252\u3002' + err);
      });
    }
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".centerdiv[data-v-35e92c56]{height:auto;text-align:center}.labright[data-v-35e92c56]{height:50px;line-height:40px}.labright[data-v-35e92c56],.rowheight[data-v-35e92c56]{text-align:right;vertical-align:middle}.textleft[data-v-35e92c56]{text-align:left;height:30px}.lableft[data-v-35e92c56]{text-align:left}.avatar-uploader .el-upload[data-v-35e92c56]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-35e92c56]:hover{border-color:#20a0ff}.avatar-uploader-icon[data-v-35e92c56]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-35e92c56]{width:178px;height:178px;display:block}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/noticePage.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAmB,CACpB,AACD,2BACE,YAAa,AACb,gBAAkB,CAGnB,AACD,uDAHE,iBAAkB,AAClB,qBAAuB,CAKxB,AACD,2BACE,gBAAiB,AACjB,WAAa,CACd,AACD,0BACE,eAAiB,CAClB,AACD,6CACE,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,oBAAsB,CACvB,AACD,uCACE,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,iBAAmB,CACpB,AACD,yBACE,YAAa,AACb,aAAc,AACd,aAAe,CAChB","file":"noticePage.vue","sourcesContent":["\n.centerdiv[data-v-35e92c56] {\n  height: auto;\n  text-align: center;\n}\n.labright[data-v-35e92c56] {\n  height: 50px;\n  line-height: 40px;\n  text-align: right;\n  vertical-align: middle;\n}\n.rowheight[data-v-35e92c56]{\n  text-align: right;\n  vertical-align: middle;\n}\n.textleft[data-v-35e92c56] {\n  text-align: left;\n  height: 30px;\n}\n.lableft[data-v-35e92c56] {\n  text-align: left;\n}\n.avatar-uploader .el-upload[data-v-35e92c56] {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar-uploader .el-upload[data-v-35e92c56]:hover {\n  border-color: #20a0ff;\n}\n.avatar-uploader-icon[data-v-35e92c56] {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar[data-v-35e92c56] {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("760acdc6", content, true);

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("公告管理")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 9
    }
  }, [_vm._v("发布新公告")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.noticeText),
      callback: function($$v) {
        _vm.noticeText = $$v
      },
      expression: "noticeText"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 9
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add_new_notice
    }
  }, [_vm._v("发布")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.7943ff9106deea29b56b.js